import { Component, OnInit } from '@angular/core';
import { GetAccount } from '@app/finxone-web-frontend/app/lib/actions/account.action';
import { FormSubmissionService } from '@app/finxone-web-frontend/app/lib/services/form-submission-service/form-submission-service.service';
import { AccountState, AccountStateModel } from '@app/finxone-web-frontend/app/lib/state/account.state';
import { FormActionTypeEnum } from '@finxone-platform/form-action';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { ProviderClass, isMultiCurrencyAccountInfoType } from '@finxone-platform/shared/sys-config-types';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject, map, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-currency-selector-widget',
  templateUrl: './currency-selector-widget.component.html',
})
export class CurrencySelectorWidgetComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Select(AccountState.getAccounts)
  private accountState$!: Observable<AccountStateModel>;
  public selectedOption: { label: string; value: string };
  public currencyListOptions: { label: string; value: string }[];

  constructor(
    public dataIn: ProviderClass<any>,
    public store: Store,
    private formSubmissionService: FormSubmissionService,
  ) {
    this.store.dispatch(new GetAccount(1, 100));
  }

  ngOnInit(): void {
    this.accountState$
      .pipe(
        takeUntil(this.destroy$),
        map((response) => {
          // Set currency options
          const accountCurrencies = response.accounts?.map((account) => {
            if (isMultiCurrencyAccountInfoType(account)) {
              return account.currency.map((currency) => ({
                label: currency.currency,
                value: account.accountId,
              }));
            } else {
              return {
                label: account.currency,
                value: account.accountId,
              };
            }
          });
          if (accountCurrencies) {
            this.currencyListOptions = accountCurrencies.flat();
          }

          // Find and set selected account
          const currentAccount =
            response.accounts?.find((v) => v.accountId === response?.currentAccountId) ??
            response?.accounts[0];
          if (!currentAccount) {
            return;
          }
          if (isMultiCurrencyAccountInfoType(currentAccount)) {
            this.setSelectedCurrencyDetails(
              response.currentMultiCurrencyCode ?? '',
              currentAccount.accountId,
            );
          } else {
            this.setSelectedCurrencyDetails(currentAccount.currency, currentAccount.accountId);
          }
        }),
      )
      .subscribe();
  }

  private setSelectedCurrencyDetails(currencyCode: string, accountId: string) {
    this.selectedOption = {
      label: currencyCode,
      value: accountId,
    };

    this.formSubmissionService.submitIndividualForm(
      {
        selectedCurrencyAccountId: accountId,
        selectedCurrency: currencyCode,
      },
      '',
      FormActionTypeEnum.BENEFICIARY_PAYMENT_CURRENCY_SELECTION,
    );
  }

  public onCurrencyChange(event: any) {
    const selectedAccount = this.currencyListOptions?.find((option) => option.value === event);
    this.formSubmissionService.submitIndividualForm(
      {
        selectedCurrencyAccountId: selectedAccount?.value,
        selectedCurrency: selectedAccount?.label,
      },
      '',
      FormActionTypeEnum.BENEFICIARY_PAYMENT_CURRENCY_SELECTION,
    );
  }
}
